const GreenRed = [
    {id: "0", value: "綠柱"},    
    {id: "1", value: "紅柱"},   
  ];  
  
  export default GreenRed